import { useCallback } from 'react';
import { useUserPreferences, useUserPreferencesMutation } from '@pm2/api';
import { FontRadio } from './atom.font-radio.js';
import { wrapper } from './molecule.group.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FontGroup() {
  const userPreferences = useUserPreferences();
  const userPreferencesMutation = useUserPreferencesMutation();
  const setFont = useCallback(font => {
    userPreferencesMutation.mutate({
      ...userPreferences,
      font
    });
  }, [userPreferences, userPreferencesMutation]);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(FontRadio, {
      name: "global-font",
      checked: userPreferences.font === "default",
      font: "proxima",
      label: "Standard skrift",
      onChange: () => setFont("default"),
      teaser: "Denne tekst er skrevet med portalens standard skrifttype."
    }), /*#__PURE__*/jsx(FontRadio, {
      name: "global-font",
      font: "dyslexie",
      checked: userPreferences.font === "dyslexie",
      label: "Dyslexie",
      onChange: () => setFont("dyslexie"),
      teaser: "Denne tekst er skrevet med dyslexie, som er lettere at l\xE6se for nogle."
    })]
  });
}

export { FontGroup };
//# sourceMappingURL=molecule.group.js.map
